import React from "react";
import { FaEye, FaRocket } from "react-icons/fa";

const VisionMission = () => {
  return (
    <section className="relative w-full py-24 px-4 md:px-20 overflow-hidden">
      {/* Background Gradient Effects */}
      {/* <div className="absolute -top-20 -left-20 w-[300px] h-[300px] bg-blue-500/20 rounded-full blur-3xl"></div> */}
      <div className="absolute top-40 -right-20 w-[300px] h-[300px] bg-purple-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-40 -left-20 w-[300px] h-[300px] bg-blue-500/20 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Vision & <span className="gradient-text">Mission</span>
          </h2>
          <p className="mt-4 text-gray-400 max-w-2xl mx-auto">
            Driving innovation, empowering businesses, and shaping the future with technology.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Vision Card */}
          <div className="group relative backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl p-10 shadow-2xl transition-all duration-300  hover:border-blue-400/50">
            
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-blue-500/20 text-blue-400 text-xl">
                <FaEye />
              </div>
              <h3 className="text-3xl font-bold text-white">Our Vision</h3>
            </div>

            <div className="space-y-6 text-gray-200 leading-relaxed text-lg">
              <div className="flex gap-4">
                <span className="text-blue-400 font-bold text-xl">01</span>
                <p>
                  Empower a knowledge-driven society with innovative IT solutions,
                  delivering simple and effective strategies tailored to client needs.
                </p>
              </div>

              <div className="flex gap-4">
                <span className="text-blue-400 font-bold text-xl">02</span>
                <p>
                  Become a trusted global leader in IT services by driving digital
                  transformation through scalable and sustainable solutions.
                </p>
              </div>
            </div>
          </div>

          {/* Mission Card */}
          <div className="group relative backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl p-10 shadow-2xl transition-all duration-300  hover:border-purple-400/50">
            
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-purple-500/20 text-purple-400 text-xl">
                <FaRocket />
              </div>
              <h3 className="text-3xl font-bold text-white">Our Mission</h3>
            </div>

            <div className="space-y-6 text-gray-200 leading-relaxed text-lg">
              <div className="flex gap-4">
                <span className="text-purple-400 font-bold text-xl">01</span>
                <p>
                  Deliver innovative and reliable IT solutions that drive business
                  growth and operational efficiency.
                </p>
              </div>

              <div className="flex gap-4">
                <span className="text-purple-400 font-bold text-xl">02</span>
                <p>
                  Understand client needs and provide tailored services that simplify
                  complex challenges while ensuring exceptional customer satisfaction.
                </p>
              </div>

              <div className="flex gap-4">
                <span className="text-purple-400 font-bold text-xl">03</span>
                <p>
                  Leverage cutting-edge technology and continuous improvement to build
                  long-term partnerships and sustainable success.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Highlight Strip */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 text-lg">
            Building future-ready digital solutions for global businesses.
          </p>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
